import styled from 'styled-components';

export const ClickOpenBelow = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  padding: 40px;
  color: var(--color-text);

  p {
    margin: 0;
  }
`;
